import type { LoadableType } from '@confluence/loadable';
import { LoadableLazy } from '@confluence/loadable';

import type { PageTreeQuickActionsProps } from './PageTreeQuickActions.tsx';

export const PageTreeQuickActions: LoadableType<PageTreeQuickActionsProps> = LoadableLazy({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-PageTreeQuickActions" */ './PageTreeQuickActions.tsx'
			)
		).PageTreeQuickActions,
});

PageTreeQuickActions.displayName = 'lazy(PageTreeQuickActions)';
